"use client";

import { useAppSelector } from "@/store/hooks";
import { datadogLogs } from "@datadog/browser-logs";
import { useEffect, useRef } from "react";

export default function DatadogInit() {
  const deployedEnv = useAppSelector((state) => state.config.deployedEnv);
  const initialized = useRef(false);

  useEffect(() => {
    if (!deployedEnv || initialized.current) {
      return;
    }
    initialized.current = true;

    datadogLogs.init({
      clientToken: "pub3c40eba81819875870f43a09bd2efb80",
      site: "us3.datadoghq.com",
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
      env: deployedEnv === "prod" ? "prod" : "stage",
      service: "nextjs-browser",
    });
  }, [deployedEnv]);

  return null;
}
